
import { Component, Vue } from "vue-property-decorator";
import { openAnketPenceresi } from "@/components/infos/anketSso";
import KatkiPaneliButton from "@/components/infos/KatkiPaneliButton.vue";

@Component({
  components: { KatkiPaneliButton }
})
export default class AnketInfo extends Vue {
  openAnket() {
    // Pop-up engelleyici / tabnabbing onlemleri anketSso icinde; bkz. openAnketPenceresi.
    return openAnketPenceresi(this.$http);
  }
}
